<template>
	<ui-modal
		title="Gerar código para captação de leads whatsapp"
		icon="fal fa-code"
		name="marketing-queues-multiple-lead-form-code"
		size="sm"
	>
		<section class="modal">
			<section class="modal-content">
				<div class="subtitle">
					Informe uma ou mais mensagens de saudação: <span>*</span>
				</div>
				<div
					class="infos-array-salutation"
					v-for="(salutation, index) in plusSalutatinoButton"
					:key="index"
				>
					<ui-input
						v-model="salutation.value"
						placeholder="Mensagem para o lead"
						design="brr-off"
					/>
					<ui-button
						v-if="
							index == plusSalutatinoButton.length - 1 &&
							plusSalutatinoButton.length <= 4
						"
						class="button-add brl-off"
						@click="newSalutation()"
					>
						+
					</ui-button>
					<ui-button
						v-else
						class="button-danger brl-off"
						@click="newSalutation('less', index)"
					>
						-
					</ui-button>
				</div>

				<div class="subtitle">Configure os canais de comunicação: <span>*</span></div>
				<ui-whatsapp-script-table
					v-model="code.code"
					:plusSalutatinoButton="plusSalutatinoButton"
				/>

				<section v-if="code.code" class="code">
					<div class="subtitle">
						Copie o código abaixo e cole antes da tag <strong><code>&#60;/body&#62;</code></strong> do seu site.
					</div>
					<ui-overlay-load v-if="loader.code" color="#2d93f8" :size="60" :stroke="8" />
					<ui-code :copy="code.doCopy">{{ code.code }}</ui-code>
				</section>
			</section>
		</section>
		<template #footer>
			<section class="buttons">
				<ui-button design="link lg" @click="cancel">Cancelar</ui-button>
				<ui-button :disabled="!code.code" design="lg primary" @click="copyCode">Copiar Código</ui-button>
			</section>
		</template>
	</ui-modal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'
	import { uiCode, uiOverlayLoad } from '@/components/ui'

	import uiWhatsappScriptTable from '../whatsapp-script-to-link-table'

	const defaultLoader = () => ({
		code: false,
	})

	const defaultCode = () => ({
		code: '',
		doCopy: false,
	})

	const defaultPlusSalutatinoButton = () => [{ value: '' }]

	export default {
		components: {
			uiModal,
			uiButton,
			uiInput,
			uiCode,
			uiOverlayLoad,
			uiWhatsappScriptTable,
		},

		data() {
			return {
				loader: { ...defaultLoader() },
				code: { ...defaultCode() },
				plusSalutatinoButton: [...defaultPlusSalutatinoButton()],
			}
		},

		methods: {
			cancel() {
				this.$root.$emit('modal-close-marketing-queues-multiple-lead-form-code')
				this.plusSalutatinoButton = [...defaultPlusSalutatinoButton()]
			},

			copyCode() {
				this.code.doCopy = true
				
				setTimeout(() => {
					this.code.doCopy = false
				}, 3000)
			},

			newSalutation(val, i) {
				if (val == 'less') {
					this.plusSalutatinoButton = this.plusSalutatinoButton.filter(
						(_result, index) => {
							return index != i
						},
					)
				} else {
					this.plusSalutatinoButton.push({ value: '' })
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
